function getCookie (name) {
  const cookie = {}
  document.cookie.split(';').forEach(function (el) {
    const [k, v] = el.split('=')
    cookie[k.trim()] = v
  })
  return cookie[name]
}

function deleteCookie (name, domain, path) {
  if (getCookie(name)) {
    document.cookie = `${name  }=${
      (path) ? `; path=${  path}` : ''
    }${(domain) ? `; domain=${  domain}` : ''
    }; Max-Age=-99999999;`
  }
}

export const cookie = {
  get: getCookie,
  delete: deleteCookie
}
